try {
  var pagewrapper = document.getElementById('page');
  var header = document.getElementById('header');
  var sticky = header.offsetTop;

  window.addEventListener('scroll', function () {
    fixHeader();
  });

  const elements = document.querySelectorAll('.animate-on-scroll');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      } else {
        entry.target.classList.remove('visible'); 
      }
    });
  }, {
    threshold: 0.05,
  });
  elements.forEach(el => observer.observe(el));

  window.addEventListener('load', function () {
    switchMainnav();

    document.querySelectorAll('a[href*="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (event) {
        const pathname = window.location.pathname.replace(/^\//, '');
        const hostname = window.location.hostname;

        if (pathname === this.pathname.replace(/^\//, '') && hostname === this.hostname) {
          let target = document.querySelector(this.hash) || document.querySelector(`[name='${this.hash.slice(1)}']`);

          if (target) {
            event.preventDefault(); 
            const topMargin = 85;
            let targetOffset = target.getBoundingClientRect().top + window.scrollY - topMargin;
            targetOffset = Math.max(targetOffset, 0);

            window.scrollTo({
              top: targetOffset,
              behavior: "smooth"
            });
          }
        }
      });
    });

    document.querySelectorAll('a[target="_blank"]').forEach(anchor => {
      anchor.setAttribute('rel', 'noopener');
    });


    document.addEventListener("DOMContentLoaded", function () {
      const backToTop = document.querySelector('.back-to-top');

      if (backToTop) {
        const offset = 220;
        const duration = 500;

        window.addEventListener('scroll', function () {
          if (window.scrollY > offset) {
            backToTop.style.transition = `opacity ${duration}ms`;
            backToTop.style.opacity = 1;
            backToTop.style.display = 'block';
          } else {
            backToTop.style.opacity = 0;
            setTimeout(() => {
              if (window.scrollY <= offset) backToTop.style.display = 'none';
            }, duration);
          }
        });

        backToTop.addEventListener('click', function (event) {
          event.preventDefault();
          window.scrollTo({top: 0, behavior: 'smooth'});
        });
      }
    });

    function resizeEffect() {
      switchMainnav();
    }

    var doit;
    window.onresize = function () {
      clearTimeout(doit);
      doit = setTimeout(resizeEffect, 250);
    };
  });
} catch (err) {
  console.log(err);
}


function switchMainnav() {
  const mobileButtons = document.querySelectorAll('.nav--main .icon-menu, .nav--main .icon-x');

  const isVisible = Array.from(mobileButtons).some(button => button.offsetParent !== null);

  if (isVisible) {
    document.querySelectorAll('.nav-header .icon-menu').forEach(button => {
      button.addEventListener('click', function () {
        this.closest('.nav-header').nextElementSibling.style.display = 'block';
        this.style.display = 'none';
        this.nextElementSibling.style.display = 'inline-block';
      });
    });

    document.querySelectorAll('.nav-header .icon-x').forEach(button => {
      button.addEventListener('click', function () {
        this.closest('.nav-header').nextElementSibling.style.display = 'none';
        this.style.display = 'none';
        this.previousElementSibling.style.display = 'inline-block';
      });
    });

    document.querySelectorAll('.nav--main .icon-plus').forEach(button => {
      button.addEventListener('click', function () {
        this.nextElementSibling.style.display = 'block';
        this.style.display = 'none';
        this.nextElementSibling.nextElementSibling.style.display = 'inline-block';

        document.querySelectorAll('.nav--main .parent').forEach(parent => {
          if (parent !== this.parentElement) {
            parent.querySelector('.nav-list').style.display = 'none';
            parent.querySelector('.icon-minus').style.display = 'none';
            parent.querySelector('.icon-plus').style.display = 'inline-block';
          }
        });
      });
    });

    document.querySelectorAll('.nav--main .icon-minus').forEach(button => {
      button.addEventListener('click', function () {
        this.previousElementSibling.style.display = 'none';
        this.style.display = 'none';
        this.previousElementSibling.previousElementSibling.style.display = 'inline-block';
      });
    });
  } else {
    document.querySelectorAll('.nav--main .nav-header, .nav--main .nav-list, .nav--main .icon-plus, .nav--main .icon-minus')
      .forEach(element => element.style.display = '');
  }
}

function fixHeader() {
  if(window.pageYOffset > sticky) {
    pagewrapper.classList.add('fixed');
    header.classList.add('fixed');
  } else {
    pagewrapper.classList.remove('fixed');
    header.classList.remove('fixed');
  }
}
